<!-- Case loading -->
@if(equipmentStatus().isLoading){
<app-skeleton-team-equipment-info />
}

<div
  class="bg-white rounded-10 p-5 max-sm:p-3 text-16 max-sm:text-12 font-roboto-400 flex flex-col gap-5"
>
  <!-- Case not loading -->
  @if(!equipmentStatus().isLoading){

  <div class="flex justify-between items-center">
    <div class="flex gap-3 items-center">
      <div class="border border-grey-5 p-1">
        <img
          alt="calendar"
          [src]="urlSVG + 'calendar.svg'"
          class="max-sm:w-[15px]"
        />
      </div>
      {{ "FoundatinoYear" | translate | uppercase }}:
    </div>
    <span class="font-roboto-800 text-blue">
      {{ teamEquipment()?.FoundationYear ?? "-" }}
    </span>
  </div>

  <div class="flex justify-between items-center">
    <div class="flex gap-3 items-center">
      <div class="border border-grey-5 p-1">
        <img
          alt="map"
          [src]="urlIMG + 'map.png'"
          class="w-[20px] max-sm:w-[15px]"
        />
      </div>
      {{ "Location" | translate | uppercase }}:
    </div>
    <span class="font-roboto-800 text-blue">
      {{ teamEquipment()?.Venue?.Name ?? "-" }} ({{
        teamEquipment()?.Venue?.City ?? "-"
      }})
    </span>
  </div>

  <!-- <div class="flex justify-between items-center">
    <div class="flex gap-3 items-center">
      <div class="border border-grey-5 p-1">
        <img
          alt="bank"
          [src]="urlIMG + 'bank.png'"
          class="w-[20px] max-sm:w-[15px]"
        />
      </div>
      {{ "MarketValue" | translate | uppercase }}:
    </div>
    <span class="font-roboto-800 text-blue text-end">
      {{ teamEquipment()?.MarketValue ?? "-" }}
      {{ teamEquipment()?.MarketValue | number : "1.0-0" }}
    </span>
  </div> -->

  <div class="flex justify-between items-center">
    <div class="flex gap-3 items-center">
      <div class="border border-grey-5 p-1">
        <img
          alt="goal"
          [src]="urlIMG + 'goal.png'"
          class="w-[20px] max-sm:w-[15px]"
        />
      </div>
      {{ "League" | translate | uppercase }}:
    </div>
    <div class="flex gap-2 items-center font-roboto-800 text-blue">
      {{ teamEquipment()?.MainCompetition?.Name ?? "-" }}
      <img
        alt="competition-logo"
        [src]="
          teamEquipment()?.MainCompetition?.ImageUrl || urlIMG + 'default.png'
        "
        class="max-w-[20px] max-sm:w-[15px]"
      />
    </div>
  </div>

  <div class="flex justify-between items-center">
    <div class="flex gap-3 items-center">
      <div class="border border-grey-5 p-1">
        <img
          alt="globe"
          [src]="urlIMG + 'globe.png'"
          class="w-[20px] max-sm:w-[15px]"
        />
      </div>
      {{ "Country" | translate | uppercase }}:
    </div>
    <div class="flex gap-2 items-center font-roboto-800 text-blue">
      {{
        getCountryName(
          teamEquipment()?.Country?.NameTranslation ?? {},
          teamEquipment()?.Country?.Name ?? ""
        )
      }}
      <img
        alt="country_logo"
        [src]="teamEquipment()?.Country?.ImageUrl || urlIMG + 'default.png'"
        class="max-w-[20px] max-sm:w-[15px]"
      />
    </div>
  </div>

  <div class="flex justify-between items-center">
    <div class="flex gap-3 items-center">
      <div class="border border-grey-5 p-1">
        <img
          alt="user"
          [src]="urlIMG + 'user.png'"
          class="w-[20px] max-sm:w-[15px]"
        />
      </div>
      {{ "Coach" | translate | uppercase }}:
    </div>
    <div class="flex gap-2 items-center font-roboto-800 text-blue">
      {{ teamEquipment()?.Coach?.Name ?? "-" }}
      <img
        alt="coach"
        [src]="teamEquipment()?.Coach?.Photo || urlIMG + 'default.png'"
        class="max-w-[20px] max-sm:w-[15px]"
      />
    </div>
  </div>

  <div
    class="bg-red-4 font-roboto-500 text-16 rounded-5 p-5 text-grey-1 mb-3 max-sm:text-13 max-sm:p-3 max-sm:mb-0"
  >
    {{ "Team" | translate }}
  </div>
  }
  <app-equipment-lineup [teamId]="teamId()" />
</div>
